import { render } from "./MemoryReport.vue?vue&type=template&id=516b95eb&scoped=true&ts=true"
import script from "./MemoryReport.vue?vue&type=script&lang=ts"
export * from "./MemoryReport.vue?vue&type=script&lang=ts"

import "./MemoryReport.vue?vue&type=style&index=0&id=516b95eb&scoped=true&lang=css"
import "./MemoryReport.vue?vue&type=style&index=1&id=516b95eb&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-516b95eb"]])

export default __exports__